import '../App.css';

function Home() {
  return (
   <div className='container'>
   <b><h1 style={{color:"#F3EFEF"}}>React Routing Project</h1></b>
   </div>
  );
}

export default Home;